import { render, staticRenderFns } from "./Messagerie.vue?vue&type=template&id=3bfdbd9a"
import script from "./Messagerie.vue?vue&type=script&lang=js"
export * from "./Messagerie.vue?vue&type=script&lang=js"
import style0 from "./Messagerie.vue?vue&type=style&index=0&id=3bfdbd9a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports